// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__lYKLk","vLegacy":"SelectSecondary_vLegacy__1tv32","error":"SelectSecondary_error__3fqFD","disabled":"SelectSecondary_disabled__3hAHP"};